import { render, staticRenderFns } from "./CustomerViewCustomerInfoCard.vue?vue&type=template&id=5dd9ad39&"
import script from "./CustomerViewCustomerInfoCard.vue?vue&type=script&lang=js&"
export * from "./CustomerViewCustomerInfoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports